import styled from 'styled-components';
import { glassDeep } from './glassmorphism';
import { scaleInAnimation } from './animations';

/**
 * Common modal components with consistent styling
 */

// Modal overlay (backdrop)
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
`;

// Modal content container
export const ModalContent = styled.div`
  ${glassDeep}
  border-radius: 16px;
  padding: 2rem;
  width: 90%;
  max-width: ${props => props.maxWidth || '600px'};
  max-height: 90vh;
  overflow: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
  animation: ${scaleInAnimation} 0.3s ease forwards;
  
  &::-webkit-scrollbar {
    width: 8px;
    background: rgba(15, 23, 42, 0.3);
    border-radius: 8px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(99, 102, 241, 0.5);
    border-radius: 8px;
    
    &:hover {
      background: rgba(99, 102, 241, 0.7);
    }
  }
`;

// Modal header
export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(99, 102, 241, 0.2);
`;

// Modal title
export const ModalTitle = styled.h2`
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-size: 1.5rem;
`;

// Close button for modals
export const CloseButton = styled.button`
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  transition: all 0.2s ease;
  border-radius: 50%;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.9);
    transform: rotate(90deg);
  }
`;

// Modal body
export const ModalBody = styled.div`
  margin-bottom: 1.5rem;
`;

// Modal footer
export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(99, 102, 241, 0.2);
`;
